import React from "react";
import styled from "styled-components";

interface IThumbnailProps {
  width?: number;
  height?: number;
  br?: string;
  src?: string;
  className?: string;
}

const Thumbnail = (props: IThumbnailProps) => {
  return (
    <ThumbnailSet className={props.className} width={props.width} height={props.height} br={props.br}>
      <img src={props.src} alt="" />
    </ThumbnailSet>
  );
};

const ThumbnailSet = styled.div<IThumbnailProps>`
  overflow: hidden;
  position: relative;
  width: ${(props) => `${props.width}px` || ""};
  height: ${(props) => `${props.height}px` || ""};
  ${(props) => props.br && `border-radius: ${props.br};`}
  img {
    max-width: 100%;
    height: auto;
    object-fit: cover;
    vertical-align: middle;
  }
`;

export default Thumbnail;
